import LayoutBasic from "@/views/layouts/LayoutBasic";
import TasksList from "@/views/tasks/TasksList";

const routes = {
  path: '/tasks',
  component: LayoutBasic, // Change the desired Layout here,
  meta: {requiresAuth: true},
  children: [
    {
      path: '/',
      component: TasksList,
      name: 'TasksList'
    },
  ]
}

export default routes
